import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";
import { useSelector } from "react-redux";
import Breadcrumbs from "../breadcrump/Breadcrump";

const PrivateLayout = ({ children }) => {
  let token = useSelector(state=> state.userReducer.token);
  let navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  return (
    <div className="layout">
      <Sidebar/>
      <div className="content">
        <Header/>
        <div className="breadkrumb_blk">
        <Breadcrumbs/>
        </div>
        <div className="childeren_blk">
        {children}
        </div>
      </div>
    </div>
  );
};


export default PrivateLayout;
